export const Type = {
    ADD_TO_BASKET: "ADD_TO_CART",
    REMOVE_FROM_BASKET: "REMOVE_FROM_BASKET",
    SET_USER:"SET_USER",
}